export enum ClientEvictionUpdateType {
  PARTIAL_PAYMENT_MADE = 'Partial Payment Made',
  INCREASE_TENANT_BALANCE = 'Increase Tenant Balance'
}
